import { createContext, useContext, useState } from 'react';
import api from '../utils/api';

const AssignedToContext = createContext();

export const AssignedToProvider = ({ children }) => {
  const [assignedToList, setAssignedToList] = useState([]);
  const [isFetched, setIsFetched] = useState(false);
  const [isFetching, setIsFetching] = useState(false);

  const fetchAssignedToList = async () => {
    if (isFetching || isFetched) return; 
    try {
      setIsFetching(true);
      const res = await api.get('/ticket/assigned-list');
      setAssignedToList(res.data);
      setIsFetched(true);
    } catch (err) {
      console.error('Error fetching assigned users:', err);
      setAssignedToList([]);
      setIsFetched(true);
    } finally {
      setIsFetching(false);
    }
  };

  return (
    <AssignedToContext.Provider value={{ assignedToList, fetchAssignedToList }}>
      {children}
    </AssignedToContext.Provider>
  );
};

export const useAssignedTo = () => {
  const context = useContext(AssignedToContext);
  if (!context) {
    throw new Error('useAssignedTo must be used within an AssignedToProvider');
  }

  const { fetchAssignedToList } = context;
  fetchAssignedToList();

  return context;
};
